export const getDebugTranslations = () =>
  localStorage.getItem('debugTranslations') || 'false'

export function puke(obj) {
  return <pre>{JSON.stringify(obj, null, ' ')}</pre>
}
